var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Plus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 32 3.0253906 C 24.575 3.0253906 17.15 5.85 11.5 11.5 C 0.2 22.8 0.2 41.2 11.5 52.5 C 17.2 58.2 24.6 61 32 61 C 39.4 61 46.8 58.2 52.5 52.5 C 63.8 41.2 63.8 22.8 52.5 11.5 C 46.85 5.85 39.425 3.0253906 32 3.0253906 z M 32 6 C 38.7 6 45.300391 8.4996094 50.400391 13.599609 C 60.500391 23.799609 60.500391 40.300391 50.400391 50.400391 C 40.200391 60.500391 23.699609 60.500391 13.599609 50.400391 C 3.4996094 40.300391 3.4996094 23.799609 13.599609 13.599609 C 18.699609 8.4996094 25.3 6 32 6 z M 32 21 C 31.2 21 30.5 21.6 30.5 22.5 L 30.5 30.5 L 22.5 30.5 C 21.6 30.5 21 31.1 21 32 C 21 32.8 21.6 33.5 22.5 33.5 L 30.5 33.5 L 30.5 41.5 C 30.5 42.3 31.1 43 32 43 C 32.8 43 33.5 42.3 33.5 41.5 L 33.5 33.5 L 41.5 33.5 C 42.3 33.5 43 32.8 43 32 C 43 31.2 42.3 30.5 41.5 30.5 L 33.5 30.5 L 33.5 22.5 C 33.5 21.6 32.8 21 32 21 z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Plus);
export default __webpack_public_path__ + "static/media/icons8-plus.70c476af95463e83655a342abb535b91.svg";
export { ForwardRef as ReactComponent };